<template>
  <HKLModal
    ref="modal"
    size="small"
    okBtnAction="ok"
    :hasCancelBtn="false"
  >
    <template slot="title">
      <slot name="title" />
    </template>
    <slot />
  </HKLModal>
</template>

<script>
import HKLModal from '@/controls/Modal/HKLModal'
import { useRefModal } from '@/controls/Modal/modal.hook'

export default {
  components: {
    HKLModal,
  },
  setup () {
    const modals = useRefModal()
    return modals
  },
}
</script>
